import React from 'react';
import { HeroKpi } from '@/components/hero-kpi';
import { InsightsPanel } from '@/components/insights-panel';
import { ResultsCard } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/result-card';
import { computeABComparisonInsight } from '@/helpers/analytics-insights.helper';
/**
 * Shared full-page layout for an A/B comparison sub-tab. Wraps the
 * existing {@link ResultsCard} with a Hero KPI + Insights panel
 * that mirror the dashboard / campaign-analytics treatment — every
 * sub-tab gets the same scannable summary before the detail table.
 *
 * Hero / Insights only render once the query has resolved; loading
 * / error states fall through to ResultsCard which has its own
 * placeholder cards for those.
 */
export function ABComparisonView({ title, description, itemName, heroLabel, comparison, loading, error, actions, }) {
    const hasData = comparison && comparison.totalScans > 0 && comparison.results.length > 0;
    const insight = React.useMemo(() => {
        if (!comparison || comparison.type === 'combination')
            return null;
        return computeABComparisonInsight({
            itemName,
            totalScans: comparison.totalScans,
            winnerLabel: comparison.winner?.label,
            winnerShare: comparison.winner?.share,
            runnerUpShare: comparison.results[1]?.share,
        });
    }, [comparison, itemName]);
    return (<div className="flex flex-col gap-4">
            {hasData ? (<div className="grid gap-4 lg:grid-cols-3">
                    <HeroKpi className="lg:col-span-2" label={heroLabel ?? `${itemName} scans`} value={comparison.totalScans.toLocaleString()} sublabel="scans across this comparison in the selected window"/>
                    <InsightsPanel insights={insight ? [insight] : []} empty="Run a few more scans and we'll surface what's winning."/>
                </div>) : null}

            <ResultsCard title={title} description={description} comparison={comparison} loading={loading} error={error} itemName={itemName} actions={actions}/>
        </div>);
}
